import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type UploadProps = IconComponentBaseProps;

export const Upload = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: UploadProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4737_34879"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4737_34879)">
        <path
          d="M6.30775 20C5.80258 20 5.375 19.825 5.025 19.475C4.675 19.125 4.5 18.6974 4.5 18.1922V16.2307C4.5 16.0179 4.57183 15.8397 4.7155 15.6962C4.859 15.5525 5.03717 15.4807 5.25 15.4807C5.46283 15.4807 5.641 15.5525 5.7845 15.6962C5.92817 15.8397 6 16.0179 6 16.2307V18.1922C6 18.2692 6.03208 18.3397 6.09625 18.4037C6.16025 18.4679 6.23075 18.5 6.30775 18.5H17.6923C17.7692 18.5 17.8398 18.4679 17.9038 18.4037C17.9679 18.3397 18 18.2692 18 18.1922V16.2307C18 16.0179 18.0718 15.8397 18.2155 15.6962C18.359 15.5525 18.5372 15.4807 18.75 15.4807C18.9628 15.4807 19.141 15.5525 19.2845 15.6962C19.4282 15.8397 19.5 16.0179 19.5 16.2307V18.1922C19.5 18.6974 19.325 19.125 18.975 19.475C18.625 19.825 18.1974 20 17.6923 20H6.30775ZM11.25 7.88845L9.327 9.81145C9.17817 9.96012 9.00158 10.0335 8.79725 10.0317C8.59275 10.0297 8.41292 9.95112 8.25775 9.79595C8.11292 9.64095 8.03792 9.46537 8.03275 9.2692C8.02758 9.07304 8.10258 8.89737 8.25775 8.7422L11.3672 5.6327C11.4609 5.53904 11.5597 5.47304 11.6635 5.4347C11.7673 5.3962 11.8795 5.37695 12 5.37695C12.1205 5.37695 12.2327 5.3962 12.3365 5.4347C12.4403 5.47304 12.5391 5.53904 12.6328 5.6327L15.7423 8.7422C15.8909 8.89087 15.9643 9.06495 15.9625 9.26445C15.9605 9.46379 15.8871 9.64095 15.7423 9.79595C15.5871 9.95112 15.4089 10.0313 15.2078 10.0365C15.0064 10.0416 14.8282 9.96662 14.673 9.81145L12.75 7.88845V15.5385C12.75 15.7513 12.6782 15.9295 12.5345 16.073C12.391 16.2166 12.2128 16.2885 12 16.2885C11.7872 16.2885 11.609 16.2166 11.4655 16.073C11.3218 15.9295 11.25 15.7513 11.25 15.5385V7.88845Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
